import { createAction } from 'typesafe-actions';
import { IReservationBookingResponse, IReservationDateTime, IReservationPerson } from '../../interfaces';

const SAVE_RESERVATION_DATE_TIME = 'SAVE RESERVATION DATE TIME';
export const saveReservationDateTime = createAction(SAVE_RESERVATION_DATE_TIME, (datetime: IReservationDateTime) => ({
    datetime,
}))();

const SAVE_RESERVATION_PERSON = 'SAVE RESERVATION PERSON';
export const saveReservationPerson = createAction(SAVE_RESERVATION_PERSON, (person: IReservationPerson) => ({
    person,
}))();

const SAVE_RESERVATION_REQUESTED = 'SAVE RESERVATION REQUESTED';
export const saveReservationRequested = createAction(
    SAVE_RESERVATION_REQUESTED,
    (restaurantId: string, reservation: IReservationDateTime, person: IReservationPerson) => ({
        restaurantId,
        reservation,
        person,
    }),
)();

const SAVE_RESERVATION_SUCCEEDED = 'SAVE RESERVATION SUCCEEDED';
export const saveReservationSucceeded = createAction(
    SAVE_RESERVATION_SUCCEEDED,
    (bookingResponse: IReservationBookingResponse) => bookingResponse,
)();

const SAVE_RESERVATION_FAILED = 'SAVE RESERVATION FAILED';
export const saveReservationFailed = createAction(SAVE_RESERVATION_FAILED, (err: any) => err)();

const RESET_ERROR = 'RESET_ERROR';
export const resetError = createAction(RESET_ERROR)();
